import React, { Fragment, memo, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import { AlertPopup, Container, DateTimeLayer, openLayerFn } from "../../Layout";

import _ICON_PLUS from "../../../resources/images/icon/icon_plus_circle_min.png";
import _ICON_MINUS from "../../../resources/images/icon/icon_minus_circle_min.png";
import { getCookie } from "../../../modules/utils/cookie";
import { AppContext, SocketCommand, socketManager, userinfoInProps } from "../../../components/AppProvider";
import { PostApi1401 } from "../../../modules/network/padoPost";
import { _O } from "../../../modules/utils";
import { maxLengthCheck } from "../../common/maxLengthCheck/maxLengthCheck";
import { userHabit } from "../../../modules/utils/UserHabit";
import { NativeAction } from "../../../modules/utils/HandleWs";

export default (props) => {
    const {userinfo, phonecfg, cfg} = useContext(AppContext);
    const sub = SUBS[0];

    // 현재 날짜 시간 기본설정
    const toDay = new Date();
    //요일 설정
    const week = new Array ("일", "월", "화", "수", "목", "금", "토");


    let defaultYear = toDay.getFullYear();
    let defaultMonth = toDay.getMonth() + 1;
    let defaultDate = toDay.getDate();

    let defaultHours = toDay.getHours();
    let defaultMin = toDay.getMinutes();

    let defaultDay = week[toDay.getDay()];
    let defaultAmPm;

    if(defaultMonth < 10) {
        defaultMonth = '0' + defaultMonth;
    }

    if(defaultDate < 10) {
        defaultDate = '0' + defaultDate;
    }

    if(defaultHours < 10) {
        defaultHours = '0' + defaultHours;
    }

    if(defaultMin < 10) {
        defaultMin = '0' + defaultMin;
    }

    if(defaultHours < 12) {
        defaultAmPm = '오전';
    } else {
        defaultAmPm = '오후';
    }

    // 9월 28일 화 오전 08:50
    const defaultValue = defaultMonth + '월' + ' ' + defaultDate + '일' + ' ' + defaultDay + ' ' + defaultAmPm + ' ' + defaultHours + ':' + defaultMin;
    const [date, setDate] = useState(defaultYear + '' + defaultMonth + '' + defaultDate);
    const [time, setTime] = useState(defaultHours + '' + defaultMin);

    const [getData, setGetData] = useState(); 
    const [inputType, setInputType] = useState("M");

    const circulateBmi = (wght, hght, target) => { 
        if(wght != '' && hght != '') {
            $('#'+ target).val(
                ((wght / (hght * hght)) * 10000).toFixed(2)
            );
        } else {
            $('#' + target).val(
                '미등록'
            );
        }
    }

    const toggleAction = (target) => {
        $("#"+target).toggle();
        $("#"+target+"Plus").toggle();
        $("#"+target+"Minus").toggle();
    }

    // BMI 수동등록
    // const request1401 = (wght, hght, BMI, SMM, bdft, vsrlft, memo) => {
    const request1401 = (wght, hght, BMI, memo) => {
        // PostApi252(userinfo, cfg, phonecfg, inputType, date, time, wght, hght, BMI, SMM, bdft, vsrlft, memo)
        PostApi1401(userinfo, cfg, phonecfg, inputType, date, time, wght, hght, BMI, memo)
        .then(res => {
            if (res.resultMsg === 'SUCCESS') {
                _O.Open("/sm/bmi/list/3/1/1");
            } else if(res.resultMsg === 'LOGOUT') {
                // openAlertPopup("다른 기기에 로그인 되어있습니다.");
                openLayerFn($('.alert-layer-logout'));
            } else {
                openAlertPopup("등록실패");
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        if(getCookie('hght')) {
            $("#inputHght").val(getCookie('hght'));
        }

        $(".toggle-inputcheck a").click(function () {
            $(this).toggleClass("off");
            // openAlertPopup("서비스 오픈 예정입니다.");
        });
    }, []);

    useEffect(()=>{
        userHabit(phonecfg, "BM111");
        NativeAction(phonecfg, "statusColor", "#7FD2C2");
    }, [phonecfg.version]);


    return(
        <Fragment>
            <Container Title='몸무게 입력' goToUrl="/sm">
                <div className="contents sub">
                    <SubMenu code={sub.code} />
                    <div className="sub-contents">
				
                        <div className="section-box">
                            <div className="sub-title">몸무게 입력</div>
                            
                            {/* <div className="toggle-inputcheck">
                                <a className="off" onClick={settingInputType}>
                                    자동입력<i></i>수동입력
                                </a>
                            </div> */}

                            <div className="device-state-info">
                                아래의 정보를 입력해주세요.
                            </div>
                            
                            <div className="meal-select-date">
                                <div>
                                    <input type="text" className="textbox datetime-picker-input pick-result" placeholder="날짜/시간을 선택해 주세요." defaultValue={defaultValue} readOnly />
                                </div>
                            </div>

                            <div className="sub-tit-input">
                                <div className="tit">몸무게</div>
                                <div className="inp-with-unit fat">
                                    <input type="number" pattern="\d*" className="textbox fat num" id="inputWght" onInput={(e) => maxLengthCheck(3, e)} placeholder="몸무게" onChange={(e)=>circulateBmi($("#inputWght").val(), $("#inputHght").val(), "inputBmi")} />
                                    <i>kg</i>
                                </div>
                            </div>
                            <div className="sub-tit-input">
                                <div className="tit">키</div>
                                <div className="inp-with-unit fat">
                                    <input type="text" className="textbox fat num" id="inputHght" placeholder="키" readOnly />
                                    <i>cm</i>
                                </div>
                            </div>
                            <div className="sub-tit-input">
                                <div className="tit">BMI</div>
                                <div className="inp-with-unit fat">
                                    <input type="text" className="textbox fat num" id="inputBmi" placeholder="BMI" readOnly/>
                                    <i>kg/㎡</i>
                                </div>
                            </div>
                        </div>

                        <div className="section-box">
                            <div className="sub-title" onClick={()=>toggleAction('etcBox')}>
                                특이사항
                                <img src={_ICON_PLUS} id="etcBoxPlus" style={{position:'absolute', width:'25px', marginLeft:'6px'}} />
                                <img src={_ICON_MINUS} id="etcBoxMinus" style={{position:'absolute', width:'25px', marginLeft:'6px', display:'none'}} />
                            </div>
                            
                            <div id="etcBox">
                                <textarea className="textarea-box gray he1" id="inputMemo" style={{resize: "none"}} maxLength="100" placeholder="특이사항 및 메모를 입력해주세요."></textarea>
                            </div>
                        </div>

                        <div className="section-box">
                            <div className="two-btns-area">
                                <a>취소</a>
                                <a className="btn-aftersave" onClick={()=>request1401($("#inputWght").val(), $("#inputHght").val(), $("#inputBmi").val(), $("#inputMemo").val())}>확인</a>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </Container>
            <DateTimeLayer setBpcDate={setDate} setBpcTime={setTime} />
            <AlertPopup />
        </Fragment>
    );
}

export const SUBS = [
    { url: "/sm/bmi/rcnt", code: "input", label: "최근몸무게" },
    { url: "/sm/bmi/history/3/1/1", code: "history", label: "몸무게이력" },
];

export const SubMenu = memo((props) => {
    const { code } = props;

    return (
        <div className="top-roundtab-contain">
            <ul className="w2">
                {SUBS.map((m, i) => (
                    <li key={i}>
                        <Link to={m.url} className={cx({ on: code === m.code })}>
                            {m.label}
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
});